import React from 'react';
import type { Index } from '../services/api';
import { PreviewViewportProvider } from './GrantedPreviewImage';
import ScopeSelectionCard from './ScopeSelectionCard';
import './IndexGallery.css';

interface IndexGalleryProps {
  indexes: Index[];
  selectedIndexId: string;
  onSelect: (indexId: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const IndexGallery: React.FC<IndexGalleryProps> = ({ indexes, selectedIndexId, onSelect, disabled = false, isLoading = false }) => (
  <PreviewViewportProvider>
    <div className="index-gallery" role="group" aria-label="Choose an index" aria-busy={isLoading}>
      {isLoading && indexes.length === 0 ? <p>Loading indexes…</p> : indexes.map((index) => (
        <ScopeSelectionCard key={index.index_id} title={index.name} description={index.description}
          secondaryText={index.video_count ? `${index.video_count} media` : 'Empty index'}
          moreCount={Math.max(0, (index.video_count || 0) - 1)}
          projection={index.preview?.thumbnail_gcs_uri ? {
            identity: { kind: 'video', video_id: index.preview.video_id },
            thumbnailGcsUri: index.preview.thumbnail_gcs_uri,
            gifGcsUri: index.preview.gif_gcs_uri || null,
          } : null}
          selected={index.index_id === selectedIndexId}
          onSelect={() => onSelect(index.index_id)} disabled={disabled} />
      ))}
      {!isLoading && indexes.length === 0 && <p>No indexes available.</p>}
    </div>
  </PreviewViewportProvider>
);

export default IndexGallery;
